module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n    <h3>Search</h3>\r\n    <p>Use the search bar at the top to search by title, citation, court, judge or keywords. <a href=\"javascript:;\" class=\"help-link\" data-article=\"440\">Boolean search operators</a> are supported.</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-search.html
// module id = 383
// module chunks = 1